





































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import Focusable from '@/mixins/Focusable'
import { naturalNumberFormatter } from '@/utils/formatters'
import { BFormInput } from 'bootstrap-vue'

@Component
export default class NumberInput extends Mixins(Vue, Validatable, Focusable) {
	$refs!: {
		focusable: BFormInput
	}

	@Prop({ type: [String, Number], default: 0 }) readonly value!: number | string
	@Prop({ type: Number, default: 0 }) readonly min!: number
	@Prop({ type: Number, default: 99 }) readonly max!: number
	@Prop({ type: Number, default: 1 }) readonly step!: number
	@Prop({ type: Boolean, default: false }) readonly required!: boolean

	protected defaultRules = [
		// TODO: вынести общее правило валидации в утилиты
		(value: number | string) => !this.required || (value !== '' || value != null) ? true : this.$t('This field is required'),
		(value: number) => value >= this.min || this.$t('Value must be greater than or equal to %s', [this.min]),
		(value: number) => value <= this.max || this.$t('Value must be less than or equal to %s', [this.max]),
	]

	created() {
		this.validate()
	}

	get state() {
		return this.errorMsg ? false
			: this.value ? true
				: null
	}

	get currentValue(): string {
		return this.value.toString()
	}

	set currentValue(value: string) {
		this.$emit('input', value || this.min)
	}

	normalizeValue(value: number) {
		value |= 0 // только целые числа и не nullable
		value = Math.min(this.max, value)
		value = Math.max(this.min, value)
		return value
	}

	increase() {
		this.currentValue = this.normalizeValue(parseInt(this.currentValue) + this.step).toString()
	}

	decrease() {
		this.currentValue = this.normalizeValue(parseInt(this.currentValue) - this.step).toString()
	}

	formatterFn(value: string) {
		return naturalNumberFormatter(value)
	}

	handleBlur() {
		this.$refs.focusable.localValue = this.value
	}
}
